
var fixed_element = document.getElementById('header');
var offset = 200;

if(fixed_element)
{

	/**
	* ADD FIXED CLASS WHEN DOWN SCROLLING
	**/
	window.addEventListener('scroll', function() {
	      if(pageYOffset > offset)
	      	{
	      		
	      		fixed_element.classList.add('fixed');

	      	} else {

	      		fixed_element.classList.remove('fixed');

	      	}
	    });

}